import { Component, OnInit } from '@angular/core';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { ConfirmStatusComponent } from 'src/app/components/confirm-status/confirm-status.component';
import { GeneralService } from '../../../../services/general.service';

@Component({
  selector: 'app-preview-qr',
  templateUrl: './preview-qr.component.html',
  styleUrls: ['./preview-qr.component.scss']
})
export class PreviewQrComponent implements OnInit {
  data: any;
  isGeneral: boolean = false;
  generalQR: string;
  multiQR: any[] = [];
  cols: number;
  width: number;
  height: number;
  generalWidth: number = 800;
  constructor(private gralService: GeneralService,
    public dialog: MatDialog) { }

  ngOnInit(): void {
    this.gralService.preparePrint.subscribe(() => {
      this.setData();
    });
  }

  setData() {
    this.data = this.gralService.getQrData();
    let withCm = this.data.generalWidth;
    this.isGeneral = this.data.isGeneral;
    this.generalQR = this.data.qrData;
    this.generalWidth = this.convertCmToPixel(withCm);

    if (!this.isGeneral) {
      this.multiQR = this.data.qrTable;
      this.cols = (this.multiQR.length > 2 ? (withCm*3 < 18 ? 3
                  : withCm*2 < 18 ? 2 : 1) : 1) ;
      this.width = this.generalWidth;
      this.height = this.generalWidth + 30;
    }

    const dialogConfig = new MatDialogConfig();
    dialogConfig.width = '350px';

    const dialogConfirmRef = this.dialog.open(ConfirmStatusComponent, dialogConfig);
    dialogConfirmRef.componentInstance.title = "Impresión";
    dialogConfirmRef.componentInstance.message = "¿Esta seguro que quiere imprimir?"

    dialogConfirmRef.afterClosed().subscribe(res => {
        if(res) {
          this.printQr();
        }
      });

  }

  convertCmToPixel(widthCm){
    let cmPx = 180 / 2.54;
    return widthCm * cmPx;
  }

  printQr() {
    window.print();
  }

}
